// Work items — page-specific strings. Expanded as the Work Items redesign
// progresses; for now this namespace holds the email-link vocabulary so a
// single sweep can update it later.

export const workItemsCopy = {
  emailLinkLabel: 'Email link',
  emailLinkHelper:
    'Paste the URL of the source email. Outlook on Mac or Windows, Outlook on the web, or a mailto address.',
  emailLinkInvalid:
    'Use a mailto: link, an Outlook desktop link, or an outlook.office.com / outlook.live.com URL.',
  openEmail: 'Open source email',
  clearEmailLink: 'Remove email link',
} as const;
